module.exports = __webpack_public_path__ + "img/ico_checkout_step_2.4bbd0bc8.svg";